import PickEmModal from '../../../@/components/PickEmModal';

interface PlayPickEmModalProps {
  bracketWebPath: string;
  onClose: () => void;
}

function PlayPickEmModal({ bracketWebPath, onClose }: PlayPickEmModalProps) {
  return (
    <PickEmModal
      bracketWebPath={bracketWebPath}
      onClose={onClose}
      bodyText="Pick the bracket and compete for a chance to win prizes!"
      buttonText="Play Now"
    />
  );
}

export default PlayPickEmModal;
